import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_upload, {
      "file-list": _ctx.value,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      action: _ctx.url,
      method: "post",
      headers: _ctx.header,
      "list-type": "picture-card",
      limit: _ctx.limit,
      multiple: _ctx.multiple,
      "on-preview": _ctx.handlePictureCardPreview,
      "before-upload": _ctx.handleBeforeUpload,
      "on-success": _ctx.handleSuccess,
      "on-error": _ctx.handleError,
      "on-exceed": _ctx.handleExceed,
      accept: ".jpg,.jpeg,.png,.gif",
      "on-change": _ctx.handleChange,
      class: _normalizeClass({disabled:_ctx.uploadDisabled}),
      "on-remove": _ctx.handleRemove
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Plus)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["file-list", "action", "headers", "limit", "multiple", "on-preview", "before-upload", "on-success", "on-error", "on-exceed", "on-change", "class", "on-remove"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          "w-full": "",
          src: _ctx.dialogImageUrl,
          style: {"width":"100%"},
          alt: "图片预览"
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}